export default __webpack_public_path__ + "static/book-selection-04b96028d1425bf81caa690909bda219.png";